<template>
  <v-app class="loginOuterOuterContainer" id="loginContainer">
    <v-card class="mt-3 ml-md-auto mr-md-auto" flat :outlined="isBreakpointReached" v-resize="onResize">
      <div id="topLogoCard" v-if="showLogoOnMobile">
        <div class="top mb-n8">
          <img :src="logo" id="topImage" />
        </div>
      </div>
      <div class="loginOuterContainer">
        <div class="loginInnerContainer">
          <div id="loginInner">
            <sign-up-form />
          </div>
        </div>
        <v-divider style="z-index: 1" vertical v-if="isDescriptionCardActive" class="d-none d-md-block" />
        <div class="loginInnerContainer" id="right" v-if="isDescriptionCardActive">
          <login-card-description :logo="logo" :title="title" :text="text" />
        </div>
      </div>
    </v-card>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import LoginCardDescription from "@/components/login/LoginCardDescription.vue";
import { LoginModule } from "@/store/modules/login.store";
import SignUpForm from "./SignUpForm.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";

@Component({
  components: { LoginCardDescription, SignUpForm }
})
export default class SignUpCard extends Vue {
  @Prop({ default: "logo" })
  logo!: string;

  @Prop({ default: "title" })
  title!: string;

  @Prop({ default: "text" })
  text!: string;

  @Prop({ default: false })
  isDescriptionCardActive?: boolean;

  @Prop({ default: false })
  showLogoOnMobile?: boolean;

  width = window.innerWidth;

  get isBreakpointReached() {
    return this.width >= 960;
  }

  onResize() {
    this.width = window.innerWidth;
  }

  async mounted() {
    let redirectTo = "/";

    if (this.$route.query.charging !== undefined) {
      redirectTo = "/charging-station/new";
    }

    if (this.$route.query.vehicle !== undefined) {
      redirectTo = "/" + ReportScreenEnum.thghome;
    }

    if (this.$route.query.affiliate !== undefined) {
      redirectTo = "/invite";
    }

    this.$log.info(`redirectTo ${redirectTo}`);

    LoginModule.setRedirect(redirectTo);
  }

  beforeUnmount() {
    LoginModule.purgeStore();
  }
}
</script>
<style scoped>
.loginOuterOuterContainer {
  height: 100%;
  overflow-y: hidden;
}
.loginOuterContainer {
  margin: auto;
  display: flex;
  justify-content: center;
}
.loginInnerContainer {
  margin: 0;
  padding: 0;
  width: 400px;
  font-size: 30px;
  min-height: 400px;
}
#right {
  font-weight: 900;
  text-align: center;
}
@media only screen and (max-width: 960px) {
  #topLogoCard {
    width: 100%;
  }
  #right {
    display: none;
  }
  #top {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
  }
  #topImage {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-height: 100px;
    max-width: 400px;
  }
  #topHeadline {
    margin: auto;
    max-width: 170px;
  }
}
@media only screen and (max-width: 400px) {
  .loginInnerContainer {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) {
  #topLogoCard {
    display: none;
  }
}
</style>
